
import BaseButton from "@/components/base/BaseButton.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import BaseSvg from "@/components/base/BaseSvg.vue";
import { defineComponent, ref } from "vue";

export default defineComponent({
	components: { BaseSection, BaseButton, BaseSvg },
	emits: ["toggled", "submit"],
	props: {
		title: String,
		loading: {
			type: Boolean,
			required: false,
		},
		isEditable: {
			type: Boolean,
			default: true
		},
	},
	setup(props, { emit }) {
		const open = ref(false);

		const toggle = () => {
			open.value = !open.value;
			emit("toggled", open.value);
		};

		const submit = () => {
			emit("submit");
		};

		return { open, toggle, submit };
	},
});
